<template>
  <div class="mainInputField">
    <label>{{ label }}</label>
    <input
      id="id"
      type="text"
      :value="value"
      :readonly="readonly"
      :placeholder="placeholder"
      :disabled="disabled"
      @input="$emit('input', $event.target.value)"
    />
    <div v-if="errors" class="helperError">{{ errors[0] }}</div>
  </div>
</template>

<script>
export default {
  name: "InputField",
  components: {},
  props: {
    label: String,
    vModel: String,
    type: String, // 'input', 'area' ,
    errors: Array,
    value: String,
    placeholder: String,
    readonly: Boolean,
    disabled: Boolean,
  },
  data() {
    return {};
  },
  mounted() {},
};
</script>
